// import React from "react";
// import { Link } from "react-router-dom";

// const Navigation = () => {
//   return (
//     <div className="navigation z-20 relative">
//       <nav className="bg-white border border-gray-300 shadow-md p-4 w-full top-0 left-0 flex justify-center">
//         <ul className="flex space-x-6 text-blue-900 font-semibold">
//           <li>
//             <Link to="/" className="hover:text-blue-700">
//               Welcome Page
//             </Link>
//           </li>
//           <li>
//             <Link to="/aboutme" className="hover:text-blue-700">
//               About Me
//             </Link>
//           </li>
//           <li>
//             <Link to="/services" className="hover:text-blue-700">
//               Services
//             </Link>
//           </li>
//           <li>
//             <Link to="/contact" className="hover:text-blue-700">
//               Contact
//             </Link>
//           </li>
//         </ul>
//       </nav>
//     </div>
//   );
// };

// export default Navigation;

import React from "react";
import { Link } from "react-router-dom";

const Navigation = () => {
  return (
    <div className="navigation z-20 relative">
      <nav className="bg-white border border-gray-400 shadow-lg p-4 w-full top-0 left-0 flex justify-center">
        <ul className="flex space-x-6 text-blue-900 font-semibold">
          <li>
            <Link to="/" className="hover:text-blue-700">
              Home
            </Link>
          </li>
          <li>
            <Link to="/aboutme" className="hover:text-blue-700">
              About Me
            </Link>
          </li>
          <li>
            <Link to="/services" className="hover:text-blue-700">
              Services
            </Link>
          </li>
          <li>
            <Link to="/contact" className="hover:text-blue-700">
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navigation;
